<template>
   <div>
    <h4 class="font-weight-regular color-headings-text margin-left-m">{{text("api.pro.productListPage.sponsors")}}</h4>
    <v-carousel hide-controls v-if="sponsors && sponsors.length > 0">
        <v-carousel-item v-for="(sponsor,i) in sponsors" :src="sponsor.logo" :key="i"  transition="fade"
                         reverse-transition="fade">
            <h4 class="font-size-medium font-weight-regular margin-bottom-s text-transform-none color-headings-text">{{sponsor.name}}</h4>
            <span class="font-size-default color-body font-weight-light">{{sponsor.claim}}</span>
        </v-carousel-item>
    </v-carousel>
   </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'SponsorsList',
        computed: mapGetters({
            sponsors: 'ProductListStore/getSponsorList'
        }),
    }
</script>



// WEBPACK FOOTER //
// src/common/components/shared/SponsorsList.vue